import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AffiliateFlagsState {
  isWebRoute?: boolean;
}

const initialState: AffiliateFlagsState = {};

export const flagsSlice = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    setIsWebRoute(state, action: PayloadAction<boolean>) {
      state.isWebRoute = action.payload;
    },
  },
});

export const { setIsWebRoute } = flagsSlice.actions;
